import { DOWN_ARROW, UP_ARROW } from "../symbols.js";
export function removeStringFromEnd(str, end) {
    return str.endsWith(end) ? str.slice(0, -end.length) : str;
}
export function removeStringFromStart(str, start) {
    return str.startsWith(start) ? str.slice(start.length) : str;
}
/**
 * appends upward arrow to string, used for indicating a departure airport in a route
 * @param s
 */
export function appendUpArrowToString(s) {
    return `${s}${UP_ARROW}`;
}
/**
 * appends downward arrow to string, used for indicating a destination airport in a route
 * @param s
 */
export function appendDownArrowToString(s) {
    return `${s}${DOWN_ARROW}`;
}
/**
 * format beacon code into 4 digit octal string
 * @param code
 */
export function convertBeaconCodeToString(code) {
    return (code ?? 0).toString(8).padStart(4, "0");
}
//# sourceMappingURL=stringManipulation.js.map